import {useCallback, useEffect, useReducer} from "react";
import {LanguagesContextDispatchMessageType} from "./LanguagesContext.interfaces";
import {initialState, reducer} from "./LanguagesContext.reducer";
import {ITeamsContext} from "../TeamsContext/TeamsContext.interfaces";
import LanguageApi from "../../apis/languageApi";

export const useLanguagesContext = (teamsContext: ITeamsContext) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(function onMount() {
        if (!teamsContext.loaded) return;
        (fetchAllLanguages)();
    }, [teamsContext.loaded]);

    const fetchAllLanguages = useCallback(async () => {
        const languages = await LanguageApi.getLanguages();
        dispatch([
            {type: LanguagesContextDispatchMessageType.SetList, list: languages},
            {type: LanguagesContextDispatchMessageType.SetLoaded, value: true}
        ]);
    }, []);

    return {
        ...state,
    }
}